"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.describeTypeStatus = exports.describeTypeNouns = exports.describeType = exports.describeSubTypeStatus = exports.describeStatus = exports.buildTypeDescription = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _helpers = require("../meta/helpers");
var statusPrefixes = {
  SLD: 'Sold',
  LSE: 'Leased'
};
var typeSuffixes = {
  ALPCUR: '',
  BUSCUR: 'for Sale',
  CLDCUR: 'for Sale',
  CLRCUR: 'for Sale',
  COMCUR: '',
  HOLCUR: 'for Rent',
  LANCUR: 'for Sale',
  LVSCUR: 'for Sale',
  LVWCUR: 'Wanted',
  RENCUR: 'for Rent',
  RURCUR: 'for Sale',
  SALCUR: 'for Sale',
  STUCUR: ''
};
var typeDescriptions = {
  ALP: ['Agistment', 'Agistments'],
  BUS: ['Business', 'Businesses'],
  CLR: ['Clearing Sale', 'Clearing Sales'],
  COM: ['Commercial', 'Commercial'],
  HOL: ['Holiday Rental', 'Holiday Rentals'],
  LVS: ['Livestock', 'Livestock'],
  LVW: ['Livestock Wanted', 'Livestock Wanted'],
  REN: ['Home', 'Homes'],
  // Rural gets a category added in the middle, see handling below
  RUR: ['Rural', 'Rural'],
  SAL: ['Home', 'Homes']
};
var subTypeDescriptions = {
  SALCUR: 'for Sale',
  LSECUR: 'for Lease',
  BOTHCUR: 'for Sale or Lease'
};
var describeStatus = statusCode => statusPrefixes[statusCode];
exports.describeStatus = describeStatus;
var describeType = function (typeCode) {
  var singular = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!typeCode) {
    return 'Properties';
  }
  return typeDescriptions[typeCode] && typeDescriptions[typeCode][singular ? 0 : 1];
};
exports.describeType = describeType;
var describeTypeStatus = (typeCode, statusCode) => {
  var _context;
  return typeSuffixes[(0, _concat.default)(_context = "".concat(typeCode)).call(_context, statusCode)] || '';
};

/**
 * Describe the subtype given the status.  When describing individual listings
 * we don't want to describe the subtype at all if not present, but when describing
 * searches nullIsAny should be set to treat no subtypes specified as any subtype.
 */
exports.describeTypeStatus = describeTypeStatus;
var describeSubTypeStatus = function (subTypeCode, statusCode) {
  var nullIsAny = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (subTypeCode && subTypeCode.not) {
    var _context2;
    var subtypes = (0, _filter.default)(_context2 = ['BOTH', 'SAL', 'LSE']).call(_context2, x => {
      var _context3;
      return (0, _indexOf.default)(_context3 = subTypeCode.not).call(_context3, x) < 0;
    });
    return describeSubTypeStatus(subtypes, statusCode, nullIsAny);
  }
  var types = (0, _isArray.default)(subTypeCode) ? subTypeCode : [subTypeCode];
  if (subTypeCode === null && nullIsAny) {
    types.pop();
    types.push('BOTH');
  }
  if (types.length === 1) {
    var _context4;
    return subTypeDescriptions[(0, _concat.default)(_context4 = "".concat(types[0])).call(_context4, statusCode)];
  }
  var hasSale = !!~(0, _indexOf.default)(types).call(types, 'SAL');
  var hasLease = !!~(0, _indexOf.default)(types).call(types, 'LSE');
  switch (true) {
    case hasSale:
      return subTypeDescriptions["SAL".concat(statusCode)];
    case hasLease:
      return subTypeDescriptions["LSE".concat(statusCode)];
    default:
      return subTypeDescriptions["BOTH".concat(statusCode)];
  }
};
exports.describeSubTypeStatus = describeSubTypeStatus;
var nouns = {
  standard: ['property', 'properties'],
  ALP: ['agistment', 'agistments'],
  BUS: ['business', 'businesses'],
  CLR: ['clearing sale', 'clearing sales'],
  COM: ['commercial listing', 'commercial listings'],
  HOL: ['holiday rental', 'holiday rentals'],
  LVS: ['livestock listing', 'livestock listings'],
  LVW: ['livestock wanted listing', 'livestock wanted listings'],
  REN: ['home', 'homes'],
  RUR: ['rural property', 'rural properties'],
  SAL: ['home', 'homes']
};
var describeTypeNouns = function (type) {
  var plural = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return nouns[type] ? nouns[type][+plural] : nouns.standard[+plural];
};
exports.describeTypeNouns = describeTypeNouns;
var buildTypeDescription = (fullName, total, statusCode, typeCode, subTypeCode, propertyTypeDescription) => {
  var _context5, _context6, _context7, _context8;
  var inverted = subTypeCode && subTypeCode.not && (0, _helpers.invertSubTypes)((0, _isArray.default)(subTypeCode.not) ? subTypeCode.not : [subTypeCode.not]);
  var miniDescription = describeStatus(statusCode) || describeTypeStatus(typeCode, statusCode) || describeSubTypeStatus(subTypeCode && (subTypeCode.in || inverted || subTypeCode), statusCode, true) || '';
  var listingTypeDescription = propertyTypeDescription || describeTypeNouns(typeCode, total !== 1);
  var typeDescription = statusCode !== 'CUR' ? (0, _concat.default)(_context5 = "".concat(miniDescription && miniDescription.toLowerCase(), " ")).call(_context5, listingTypeDescription) : (0, _concat.default)(_context6 = "".concat(listingTypeDescription, " ")).call(_context6, miniDescription && miniDescription.toLowerCase());
  return (0, _concat.default)(_context7 = (0, _concat.default)(_context8 = "".concat(fullName, " has ")).call(_context8, total && total, " ")).call(_context7, typeDescription);
};
exports.buildTypeDescription = buildTypeDescription;